import {
  Anchor,
  Box,
  Container,
  Divider,
  Group,
  Image,
  SimpleGrid,
  Stack,
  Text,
} from "@mantine/core";
import { Link } from "react-router-dom";

export function Footer() {
  return (
    <Box
      component="footer"
      bg="white"
      py={64}
      style={{ borderTop: "1px solid var(--mantine-color-gray-2)" }}
    >
      <Container size="lg">
        <SimpleGrid cols={{ base: 1, sm: 3 }} spacing="xl">
          <Stack gap="sm">
            <Group gap="xs">
              <Image src="/logo.svg" w={32} h={32} alt="Verdana" />
              <Text fw={700} fz="lg">
                Verdana
              </Text>
            </Group>
            <Text c="gray.7" fz="sm" lh={1.55}>
              Gestão descomplicada para o seu negócio. Feito por uma equipe pequena, para pequenos
              negócios.
            </Text>
          </Stack>

          <Stack gap="sm">
            <Text fw={600}>Navegação</Text>
            <Anchor href="/#features" c="gray.7" fz="sm" underline="never">
              Funcionalidades
            </Anchor>
            <Anchor href="/#pricing" c="gray.7" fz="sm" underline="never">
              Preço
            </Anchor>
            <Anchor href="/#faq" c="gray.7" fz="sm" underline="never">
              Dúvidas
            </Anchor>
          </Stack>

          <Stack gap="sm">
            <Text fw={600}>Legal</Text>
            <Anchor component={Link} to="/terms" c="gray.7" fz="sm" underline="never">
              Termos de Uso
            </Anchor>
            <Anchor component={Link} to="/privacy" c="gray.7" fz="sm" underline="never">
              Política de Privacidade
            </Anchor>
            <Text c="gray.7" fz="sm" mt="xs">
              WhatsApp: (87) 99173-9334
            </Text>
          </Stack>
        </SimpleGrid>

        <Divider my="xl" />

        <Group justify="space-between">
          <Text c="gray.6" fz="sm">
            © 2026 Verdana. Todos os direitos reservados.
          </Text>
          <Text c="gray.6" fz="sm">
            Garanhuns, PE 💚
          </Text>
        </Group>
      </Container>
    </Box>
  );
}
